import React, { useContext, useEffect, useState } from "react";
import {
    get_rawtransaction,
    getUnits,
    // delete_rawtransaction
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { isReadonlyRoute, NaviGate } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import { useLocation } from "react-router-dom";
import { EditRawTransection } from "./rtransfrm";

function Raw_transection() {
    const { pathname } = useLocation();
    const readonly = isReadonlyRoute(pathname);
    const { showLoader, hideLoader } = useContext(WarehouseContext);

    const [rawmaterials, setRawmaterials] = useState([]);
    const [selectedRaw, setSelectedRaw] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [addOrEdit, setAddOrEdit] = useState(true);
    const [transactionType, setTransactionType] = useState("1");
    const [preSelectedMaterial, setPreSelectedMaterial] = useState(null);
    const [viewType, setViewType] = useState("add"); // "add" or "taken"

    const [deleteID, setDeleteID] = useState("");
    const [deletemodel, showDeletemodel] = useState(false);

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const rolesPerPage = 10;
    const [searchText, setSearchText] = useState("");
    const [unitsList, setUnitsList] = useState([]);

    useEffect(() => {
        fetchRawmaterials();
    }, [viewType]);

    useEffect(() => {
        fetchUnitsList();
    }, []);

    const fetchUnitsList = async () => {
        try {
            const response = await getUnits();
            if (response.data && response.data.data) {
                setUnitsList(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching units:", error);
        }
    };

    const getUnitName = (unitId) => {
        if (!unitId) return "";
        const found = unitsList.find(u => String(u.id) === String(unitId));
        if (found) return found.title;
        if (String(unitId) === "1") return "kg";
        if (String(unitId) === "2") return "gram";
        return unitId;
    };

    const handledeletemodel = (ID) => {
        showDeletemodel(true);
        setDeleteID(ID);
    };

    const fetchRawmaterials = async (page = 1, text = searchText) => {
        showLoader();
        try {
            const addTakenParam = viewType === "add" ? "1" : "0";
            const response = await get_rawtransaction(page, rolesPerPage, text, addTakenParam);
            if (response.data && response.data.data) {
                setRawmaterials(response.data.data);
                setTotalPages(response.data.pagination?.total_pages || 1);
            }
        } catch (error) {
            console.error("Error fetching raw materials:", error);
            toast.error("Failed to fetch raw materials");
        } finally {
            hideLoader();
        }
    };

    const openAddModal = (type = "1", material = null) => {
        setAddOrEdit(true);
        setSelectedRaw(null);
        setTransactionType(type);
        setPreSelectedMaterial(material);
        setShowEditModal(true);
    };

    const openEditModal = (raw) => {
        setSelectedRaw(raw);
        setAddOrEdit(false);
        setPreSelectedMaterial(null);
        setShowEditModal(true);
    };

    const handleDelete = async () => {
        // if (!deleteID) {
        //     toast.error("No raw material selected to delete");
        //     return;
        // }

        // try {
        //     await delete_rawtransaction(deleteID);
        //     showDeletemodel(false);
        //     toast.success("Raw material deleted");
        //     fetchRawmaterials(currentPage);
        // } catch (error) {
        //     console.error("Error deleting raw material:", error);
        //     toast.error("Error deleting raw material");
        // }
    };

    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
        fetchRawmaterials(pageNumber, searchText);
    };


    const handleSearch = async (text) => {
        setSearchText(text); // save current search
        fetchRawmaterials(1, text);
        setCurrentPage(1);
    };

    const handleViewTypeChange = (type) => {
        setViewType(type);
        setCurrentPage(1);
    };

    return (
        <div className="page-wrappers">
            <div className="page-content">
                <NaviGate />
                <div className="mb-0 d-flex justify-content-between align-items-center">
                    <h6
                        className="mb-0 text-uppercase"
                        style={{ fontFamily: "poppins" }}
                    >
                        Raw Transaction List
                    </h6>
                    {!readonly && (
                        <div>
                            {/* <button
                                type="button"
                                onClick={() => openAddModal("1")}
                                className="btn btn-success mb-0 me-2"
                                style={{ fontFamily: "poppins" }}
                            >
                                Add New Stock
                            </button> */}
                            {/* <button
                                type="button"
                                onClick={() => openAddModal("0")}
                                className="btn btn-warning mb-0"
                                style={{ fontFamily: "poppins" }}
                            >
                                Take Stock
                            </button> */}
                        </div>
                    )}
                </div>
                <hr className="mt-1" />

                <div className="card">
                    <div className="card-body">
                        <div className="row mb-3 align-items-center">
                            <div className="col-12 col-md-6 col-lg-4">
                                <div
                                    className="d-flex position-relative"
                                    style={{ width: "100%" }}
                                >
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Search..."
                                        onChange={(e) => handleSearch(e.target.value)}
                                    />
                                    <img
                                        src="/assets/images/icons/search.png"
                                        alt="Search Icon"
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            height: "18px",
                                            pointerEvents: "none",
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-8 text-end">
                                <button
                                    type="button"
                                    className={`btn btn-sm ${viewType === "add" ? "btn-primary" : "btn-outline-primary"} me-2`}
                                    onClick={() => handleViewTypeChange("add")}
                                >
                                    Add List
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-sm ${viewType === "taken" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => handleViewTypeChange("taken")}
                                >
                                    Taken List
                                </button>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table
                                className="table table-striped table-sm table-bordered"
                                style={{ width: "100%", fontFamily: "poppins" }}
                            >
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Date</th>
                                        <th>Supplier</th>
                                        <th>Title</th>
                                        <th>Price (INR)</th>
                                        <th>{viewType === "add" ? "Total Qty" : "Taken Qty"}</th>
                                        {viewType === "add" && <th>Remaining</th>}
                                        {/* {viewType === "taken" && <th>Date</th>} */}
                                        {/* {!readonly && viewType === "add" && <th>Actions</th>} */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rawmaterials.map((raw, index) => (
                                        <tr key={raw.id}>
                                            <td>{(currentPage - 1) * rolesPerPage + index + 1}</td>
                                            <td>
                                                {new Date(raw.date_time).toLocaleDateString("en-GB", {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric",
                                                })}
                                            </td>
                                            <td>{raw.supplier_name}</td>
                                            <td>{raw.title}</td>
                                            {/* <td>
                                                {raw.qty != null ? Number(raw.qty).toFixed(2) : "0.00"}{" "} {raw.unit_id === "1" ? "kg" : raw.unit_id === "2" ? "gram" : ""}
                                            </td> */}
                                            <td>
                                                {raw.price != null ? Number(raw.price).toFixed(2) : "0.00"}
                                            </td>
                                            <td>
                                                {/* {raw.qty != null ? Number(raw.qty).toFixed(2) : "0.00"}{" "} {raw.unit_id === "1" ? "kg" : raw.unit_id === "2" ? "gram" : ""} */}
                                                {raw.qty != null ? Number(raw.qty).toFixed(2) : "0.00"}{" "} {getUnitName(raw.unit_id)}
                                            </td>
                                            {/* {viewType === "add" && <td>{Number(raw.remaining).toFixed(1)}{" "} {raw.unit_id === "1" ? "kg" : raw.unit_id === "2" ? "gram" : ""}</td>} */}
                                            {viewType === "add" && <td>{Number(raw.remaining).toFixed(1)}{" "} {getUnitName(raw.unit_id)}</td>}
                                            {/* {viewType === "taken" && (<td>{raw.expdate ? raw.expdate : "-"}</td>)} */}

                                            {/* {!readonly && viewType === "add" && (
                                                <td> */}
                                            {/* <button
                                                        type="button"
                                                        className="btn btn-sm btn-success me-1"
                                                        onClick={() => openAddModal("1", raw)}
                                                        title="Add Stock"
                                                    >
                                                        <i className="bi bi-plus"></i> Add
                                                    </button> */}
                                            {/* <img
                                                        src="/assets/images/icons/add.png"
                                                        onClick={() => openAddModal("1", raw)}
                                                        height="18px"
                                                        alt="Add"
                                                        style={{ cursor: "pointer", marginRight: "8px" }}
                                                        title="Add Stock"
                                                    />  */}
                                            {/* <button
                                                        type="button"
                                                        className="btn btn-sm btn-warning me-1"
                                                        onClick={() => openAddModal("0", raw)}
                                                        title="Take Stock"
                                                    >
                                                        <i className="bi bi-dash"></i> Take
                                                    </button> */}


                                            {/* <img
                                                        src="/assets/images/icons/take-cart.png"
                                                        onClick={() => openAddModal("0", raw)}
                                                        height="16px"
                                                        alt="Take Stock"
                                                        style={{ cursor: "pointer", marginRight: "8px" }}
                                                        title="Take Stock"
                                                    /> */}

                                            {/* <img
                                                        src="/assets/images/icons/edit.png"
                                                        onClick={() => openEditModal(raw)}
                                                        height="16px"
                                                        alt="Edit"
                                                        style={{ cursor: "pointer", marginRight: "8px" }}
                                                        title="Edit"
                                                    /> */}
                                            {/* <img
                                                        src="/assets/images/icons/delete.png"
                                                        onClick={() => handledeletemodel(raw.id)}
                                                        height="16px"
                                                        alt="Delete"
                                                    style={{ cursor: "pointer" }}
                                                        title="Delete"
                                                    /> */}
                                            {/* </td>
                                            )} */}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {deletemodel && (
                <Deletemodel
                    setShowModal={showDeletemodel}
                    handleDelete={handleDelete}
                />
            )}

            {showEditModal && (
                <EditRawTransection
                    showModal={showEditModal}
                    setShowModal={setShowEditModal}
                    fetchRawmaterials={fetchRawmaterials}
                    selectedRawmaterial={selectedRaw}
                    AddorEdit={addOrEdit}
                    transactionType={transactionType}
                    preSelectedMaterial={preSelectedMaterial}
                    setCurrentPage={setCurrentPage}
                />
            )}
        </div>
    );
}

export default Raw_transection;


